
export const numberWithCommas = function(num) {
	return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const facebookShare = function(appId, shareImage, shareURL, shareMsg, shareRedirectURI){
	
	var url = "https://www.facebook.com/dialog/feed";
	url += "?app_id=" + appId;
	url += "&description=" + encodeURIComponent(shareMsg);
	url += "&picture=" + encodeURIComponent(shareImage);
	url += "&link=" + encodeURIComponent(shareURL);
	url += "&redirect_uri=" + encodeURIComponent(shareRedirectURI);
	url += "&display=popup";

	window.open(url, "_blank");

}

export const twitterShare = function(shareMsg, shareURL){

	var url = "https://twitter.com/intent/tweet";
	url += "?text=" + encodeURIComponent(shareMsg);
	url += "&url=" + encodeURIComponent(shareURL);

	window.open(url, "_blank");
}



// WEBPACK FOOTER //
// ./src/js/utils/utils.js